/**
 * @file layout-constants.ts
 *
 * Shared layout constants for the Online Shop admin shell. Centralizes values
 * that are reused across the layout so they are not scattered as magic numbers.
 */

/** Max content width (px) of the admin content column, matching the WSB-v2 shop. */
export const AdminLayoutContentWidth = 1440;
